<template>
  <div class="header-banner header-banner_bg"
  >
    <div class="bannerTitle">{{ bannerTitle }}</div>


    <!--左侧-->
    <div class="banner-left">
      <!--      1正常banner-->
      <template v-if="type==1">
        <div v-for="item in modelList" :key="item.id">
          <LeftYellow v-if="form.module==item.value" class="btn_item" :item="item"
                      :handleClick="moduleItemClick"/>
          <LeftBlue v-else class="btn_item" :item="item" :handleClick="moduleItemClick"/>
        </div>
      </template>


      <div v-if="type==2" class="back_box">
        <img class="back" src="../../../assets/back.png" alt="" @click="toBack">
      </div>

      <!--      2左侧数据源-->
      <template v-if="type==2">
        <div v-for="item in dataList" :key="item.id">
          <LeftYellow v-if="form.platform==item.value" class="btn_item" :item="item"
                      :handleClick="platformItemClick"/>
          <LeftBlue v-else class="btn_item" :item="item" :handleClick="platformItemClick"/>
        </div>
      </template>


    </div>
    <!--    中间-->
    <div class="banner-center">

    </div>


    <!--右侧-->
    <div class="banner-right">
      <!--      1正常banner-->
      <template v-if="type==1&&form.module!=8">


        <div v-for="item in dataList" :key="item.id">
          <RightYellow v-if="form.platform==item.value" class="btn_item" :item="item"
                       :handleClick="platformItemClick"/>
          <RightBlue v-else class="btn_item" :item="item" :handleClick="platformItemClick"/>
        </div>
      </template>

      <!--      右侧时间-->
      <template v-if="type==2">
        <div v-if="rightBoxType==0"></div>
        <NowTime v-if="rightBoxType==1" class="time_box"/>
      </template>

      <!--用户信息-->
      <div class="user_box">
        <el-image
            class="img"
            :src="'https://mp.hd-bkt.bobiton.com/' + userInfo.avatar"></el-image>
        <div class="username">{{ userInfo.nickname }}</div>
        <el-dropdown @command="menuClick" trigger="click">
          <img class="logout" src="@/assets/logout.png">
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>登出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

      </div>
    </div>

    <el-dialog
        title="温馨提示"
        :visible.sync="logoutVisible"
        width="400px">
      <div style="display: flex;flex-direction: column;align-items: center;gap: 10px;color: white;">
        <img src="../../../assets/happy.png">
        <span >确认退出登录？</span>
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="logoutVisible = false">取 消</el-button>
    <el-button type="primary" @click="logout">确 定</el-button>
  </span>
    </el-dialog>


  </div>
</template>

<script>
import NowTime from '@/components/nowTime'
import LeftYellow from './bannerComponents/left_yellow.vue'
import LeftBlue from './bannerComponents/left_blue.vue'
import RightBlue from './bannerComponents/right_blue.vue'
import RightYellow from './bannerComponents/right_yellow.vue'

export default {
  components: {
    NowTime,
    LeftYellow,
    RightBlue,
    LeftBlue,
    RightYellow,
  },
  props: {
    bannerTitle: { //标题，无标题默认 “保彼通数据大屏”
      type: String,
      default: "保彼通数据大屏"
    },
    form: {
      type: Object,
      default: {}
    },
    sendMessage: {
      type: Function,
      default: () => {
      }
    },
    type: {
      type: Number,
      default: 1,// 1正常banner、2只有左侧数据源
    },
    rightBoxType: {
      type: Number,
      default: 0,// 0无东西，1实时时间
    }
  },
  data() {
    return {
      modelList: [
        {
          label: '兵工场',
          value: 1
        },
        {
          label: '机构',
          value: 2
        },
        {
          label: '分销者',
          value: 3
        },
        {
          label: '产品',
          value: 4
        },
        {
          label: '商家',
          value: 8
        }
      ],
      dataList: [
        {
          label: '快手',
          value: 1
        },
        {
          label: '视频号',
          value: 2
        },
        {
          label: '抖音',
          value: 3
        },

      ],
      userInfo: {},


      logoutVisible: false,
    }
  },
  created() {
    this.userInfo = JSON.parse(window.localStorage.getItem('userinfo'))
    // 单机构需要隐藏其他数据源
    if (this.$route.name == 'OrgOne') {
      this.form.platform = this.$route.query.platform
      this.dataList = this.dataList.filter(f => f.value == this.form.platform)
    }
  },
  watch: {},
  methods: {
    // 修改功能
    moduleItemClick(item) {
      this.$emit('update:form', {
        ...this.form,
        module: item.value
      });
      this.sendMessage()
    },
    // 修改数据源
    platformItemClick(item) {
      if (item.value == 3) {
        const imageUrl = require('../../../assets/happy.png');
        this.$message({
          dangerouslyUseHTMLString: true,
          message: `      <div style="height: 100%;display: flex;flex-direction: column;gap: 20px;">
        <div style="margin-left: 20px;">温馨提示</div>
            <div style="width: 320px;
            display: flex;flex-direction: column;
  justify-content: center;
  align-items: center;  gap:20px;"
  >
                <img style="width: 50px;height: 50px;" src="${imageUrl}"/>
                <div >即将上线，敬请期待！</div>
            </div>
      </div>
      `
        });
        return
      }
      this.$emit('update:form', {
        ...this.form,
        platform: item.value
      });
      this.sendMessage()
    },
    menuClick() {
      this.logoutVisible = true
    },
    logout() {
      // 清除所有localStorage
      localStorage.clear();
      window.location.replace('/login');
    },
    toBack() {
      this.$router.go(-1);
    },
  }

}
</script>


<style lang="scss" scoped>

::v-deep(.el-dialog){
  background: url(../../../assets/message_bg.png) no-repeat !important;
  background-size: 100% 100% !important;
  background-color: transparent !important;
  padding: 20px;
}

::v-deep(.el-dialog__title){
  color: white !important;
}

::v-deep(.el-dialog__headerbtn .el-dialog__close){
  margin-right: 20px !important;
  color: white !important;
}


.header-banner {
  width: 100%;
  height: 90px;
  display: flex;
  align-items: center;
  background: url(../../../assets/_s-top_image_tab_bg.png) no-repeat center top;
  background-size: 1000px 80px;

  .bannerTitle {
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0);
    font-size: 40px;
    font-weight: 700;
    color: white;
  }
}


.banner-left {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  gap: 10px;

  .back_box {
    flex: 1;
    padding-left: 16px;
    color: white;

    .back {
      width: 50px;
      height: 50px;
      cursor: pointer;
    }
  }

  .btn_item {
    width: 120px;
    height: 40px;
  }

}

.banner-center {
  width: 600px;
}

.banner-right {
  flex: 1;
  display: flex;
  gap: 10px;
  padding-right: 10px;


  .btn_item {
    width: 120px;
    height: 40px;
  }


  .time_box {
    width: 420px;
    height: 40px;
    margin-top: 10px;
    margin-left: 30px;
  }

  .user_box {
    flex: 1;
    height: 50px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 10px;
    font-size: 20px;
    color: white;

    .img {
      width: 40px;
      height: 40px;
      border-radius: 25px;
    }

    .username {
      max-width: 150px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .logout {
      width: 24px;
      height: 24px;
      cursor: pointer;
    }
  }


}
</style>